import React, {useState} from "react";
import {axiosInstance} from "../../config/http";
import {useSearchParams, useNavigate} from "react-router-dom";
import {LeftLogoPane, Logos, PageWrapper, RightFormPane} from "../login/styled";
import iriLogo from "../../assets/IRI_logo.jpg";
import columbiaLogo from "../../assets/columbia_logo.png"
import {Button, InputBox} from "../../common/styled";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const email = searchParams.get("email");
  const navigate = useNavigate();

  const [password, setPassword] = useState('')
  const [msg, setMsg] = useState('')
  const [success, setSuccess] = useState(false)

  const resetPassword = async () => {
    setMsg('')
    try {
      await axiosInstance.post('/reset_password', {
        email: email,
        password: password,
        token: token,
      })
      setSuccess(true)
      setTimeout(() => navigate('/login'), 2000)
    } catch (e) {
      if (e.response && e.response.data && e.response.data.msg) {
        setMsg(e.response.data.msg)
      } else {
        setMsg('Something went wrong. Please try again.')
      }
    }
  }

  return (
    <PageWrapper>
      <LeftLogoPane>
        <span>DESDR NOKi</span>
        <span>SURVEY YOUR WAY</span>
        <Logos>
          <img src={iriLogo}/>
          <img src={columbiaLogo}/>
        </Logos>
      </LeftLogoPane>
      <RightFormPane>
        {success ? (
          <p>Password reset successful! Redirecting to login...</p>
        ) : (
          <>
            <InputBox placeholder={'Email'} type={'text'} value={email || ''} disabled/>
            <InputBox placeholder={'New password'} type={'password'} onChange={(e) => setPassword(e.target.value)}
                   value={password}/>
            <Button onClick={resetPassword}>Reset Password</Button>
            {msg && <p style={{color: 'red', fontSize: '12px', marginTop: '5px'}}>{msg}</p>}
          </>
        )}
      </RightFormPane>
    </PageWrapper>
  )
}

export default ResetPassword;